import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 98%;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
`;

export const Rectangle = styled.div`
  flex: 1;
  height: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(204, 204, 220, 0.12);
  border-radius: 2px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.div`
  width: 100%;
  text-align: left;
  padding: 10px;
  font-weight: bold;
  font-size: 18px;
`;

export const ColorBar = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.color || '#ccc'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 52px;
  font-weight: bold;
  text-align: center;
`;

export const TableWrapper = styled.div`
  width: 98%;
  margin-bottom: 10px;
`;
